// All svg components were generated by vue-svgicon using svg files
// https://github.com/MMF-FE/vue-svgicon

// Require all svg components in svg folder
// https://webpack.js.org/guides/dependency-management/#require-context
const requireAll = (requireContext: any) => requireContext.keys().forEach(requireContext)
requireAll(require.context('./components', false, /\.ts$/))
